import React from 'react';
import appRoutes from './appRoutes';
import SidebarItem from './SidebarItem';
import SidebarItemCollapse from './SidebarItemCollapse';
import { Box, Divider, List } from '@mui/material';
import { managementRoutes } from './managementRoutes';

export const OpenSidebar = () => {
  return (
    <Box display="flex" flexDirection="column" flex={1} sx={{ overflowY: 'auto' }}>
      <List>
        {/* Key by path: items appear once permissions load, so indexes shift. */}
        {appRoutes().map(route =>
          route.sidebarProps ? (
            route.child ? (
              <SidebarItemCollapse item={route} key={route.path} />
            ) : (
              <SidebarItem item={route} key={route.path} />
            )
          ) : null,
        )}
      </List>
      <Divider sx={{ mt: 2, mb: 1 }} />
      <Box flexGrow={1} />
      <List>
        {managementRoutes().map((route, index) =>
          route.sidebarProps ? <SidebarItem item={route} key={index} /> : null,
        )}
      </List>
    </Box>
  );
};
